import React, { useCallback, useEffect, useRef } from "react";

import { pinIcons } from 'img/icons'

const apikey = 'OLCoyPaF7svsuTqJ7-ef8eP4wxxuN1_hy_XhkBGH8zY';
const Here = window.H;


export default function HereMap ({
	plugins, center, zoom, markers=[], selected, route=false, style, className,
}) {

	const mapRef = useRef()
	const mapDomRef = useRef()
	const platformRef = useRef()
	const routerRef = useRef()
	const uiRef = useRef()
	const markersGroupRef = useRef()
	const routeGroupRef = useRef()
	const bubbleRef = useRef()


	//// funzioni di manipolazione marker

	const getDistance = useCallback((lat1, lon1, lat2, lon2)  => {
		let f1 = lat1 * Math.PI / 180, f2 = lat2* Math.PI / 180, dl = (lon2-lon1)* Math.PI / 180, R = 6371e3; // gives d in metres
		let d = Math.acos( Math.sin(f1)*Math.sin(f2) + Math.cos(f1)*Math.cos(f2) * Math.cos(dl) ) * R;
		return d / 1000;
	}, [])

	const addMarkers = useCallback(markers => {
		if (!mapRef.current) return
		if (!markers || markers.length === 0) return

		if (markersGroupRef.current) mapRef.current.removeObject(markersGroupRef.current)
		markersGroupRef.current = new Here.map.Group()
		mapRef.current.addObject(markersGroupRef.current)

		// add 'tap' event listener, that opens info bubble, to the markersGroup
		markersGroupRef.current.addEventListener('pointermove',  (evt) => {
			// event target is the marker itself, markersGroup is a parent event target
			// for all objects that it contains
			if (bubbleRef.current) uiRef.current.removeBubble(bubbleRef.current);
			bubbleRef.current =  new Here.ui.InfoBubble(evt.target.getGeometry(), {
				// read custom data
				content: evt.target.getData()
			});

			bubbleRef.current.addEventListener("statechange", ({target}) => {
				if (target.getState() === 'closed') {
					uiRef.current.removeBubble(bubbleRef.current)
					bubbleRef.current = null
				}
			});
			// show info bubble
			uiRef.current.addBubble(bubbleRef.current)
		}, false);

		markers.forEach((m) => {
			let coords = { lat: m.lat, lng: m.lng };
			let marker;
			if (m.icon) {
				let icon = new Here.map.Icon(m.icon);
				marker = new Here.map.Marker(coords, {icon});
			} else {
				marker = new Here.map.Marker(coords);
			}
			// Add the marker to the map and center the map at the location of the marker:
			marker.setData(m.data);
			if(m.lat && m.lng)
			markersGroupRef.current.addObject(marker);
		});
	}, [])

	const drawRoute = useCallback((points=[]) => {
		if (!mapRef.current) return
		let threshold = 1;
		while (points.length > 200) {
			points = points.filter((m, i, data) => {
				return m.icon !== pinIcons.stillAlive && (i === 0 || getDistance(m.lat, m.lng, data[i-1].lat, data[i-1].lng) > threshold)
			});
			threshold *= 1.1;
		}

		let mode = {
			car: 'car',
			pedestrian: 'pedestrian',
		};
		let pointToRouteParam = p => `${p.lat},${p.lng}`;

		// punti intermedi percorso
		let viaParams = null;
		if (points.length > 2) {
			viaParams = new Here.service.Url.MultiValueQueryParameter(
				points.slice(1, points.length - 1).map(pointToRouteParam));
		}

		let calculateRouteParams = {
			'origin': pointToRouteParam(points[0]),
			'destination': pointToRouteParam(points[points.length-1]),
			'via': viaParams,
			'transportMode': mode.car,
			'routingMode': 'fast',
			'return': 'polyline',
		};

		let onResult = result => {
			if(result.type === "ApplicationError") {
				if(result.subtype === "NoRouteFound" && calculateRouteParams.transportMode === mode.car) {
					calculateRouteParams.transportMode = mode.pedestrian;
					routerRef.current.calculateRoute(calculateRouteParams, onResult, (e) => console.log("pedestrian", e));
				} else {
					console.log(result.details);
				}
			} else {
				if(result.routes[0].sections) {
					const sections = result.routes[0].sections;
					const lineStrings = [];

					// ripulisce le route
                    if (routeGroupRef.current) mapRef.current.removeObject(routeGroupRef.current)
                    routeGroupRef.current = new Here.map.Group()

					sections.forEach((section) => {
					  	// convert Flexible Polyline encoded string to geometry
						lineStrings.push(Here.geo.LineString.fromFlexiblePolyline(section.polyline));
					});
					const multiLineString = new Here.geo.MultiLineString(lineStrings);
					const bounds = multiLineString.getBoundingBox();
					const polyline = new Here.map.Polyline(multiLineString, {
						style: {
							strokeColor: '#AB2430', lineWidth: 8,
							lineDash: [2, 1], lineDashImage: Here.map.SpatialStyle.DashImage.ARROW,
						},
					});

                    // render route on the map
					routeGroupRef.current.addObject(polyline)
                    mapRef.current.addObject(routeGroupRef.current)

					// zoom to polyline
					mapRef.current.getViewModel().setLookAtData({bounds})
				}
			}
		};
		let onError = function(error) {
			console.log(error);
		};
		routerRef.current.calculateRoute(calculateRouteParams, onResult, onError)
	}, [getDistance])

	const clear = useCallback(() => {
		if (!mapRef.current) return
		if (routeGroupRef.current) {
			mapRef.current.removeObject(routeGroupRef.current)
			routeGroupRef.current = null
		}
		if (markersGroupRef.current) {
			mapRef.current.removeObject(markersGroupRef.current)
			markersGroupRef.current = null
		}
	}, [])


	//// inizializza la mappa
	useEffect(() => {
		platformRef.current = new Here.service.Platform({
			apikey,
			useCIT: true,
			useHTTPS: true,
		});

		let container = mapDomRef.current
		let engineType = Here.Map.EngineType['HARP']
		let layer = platformRef.current.createDefaultLayers({ engineType: engineType })
		
		mapRef.current = new Here.Map(container, layer.vector.normal.map, {
			center: { lat:42.5, lng:12.5 },
			zoom: 10,
			engineType: engineType,
		})
		uiRef.current = new Here.ui.UI.createDefault(mapRef.current, layer, 'it-IT')
		routerRef.current = platformRef.current.getRoutingService(null, 8)
		
		// Enable the event system on the map instance
		let mapEvents = new Here.mapevents.MapEvents(mapRef.current)
		let behavior = new Here.mapevents.Behavior(mapEvents)

		// imposta plugins
		if (plugins?.length > 0) {
			plugins.forEach(plugin => {
				plugin(mapRef.current)
			})
		}

		let resizeTimeout
		let handleResize = () => {
			clearTimeout(resizeTimeout)
			resizeTimeout = setTimeout(() => {
				mapRef.current.getViewPort().resize()
			}, 1000)
		}
		window.addEventListener("resize", handleResize)

		// cleanup
		return () => {
			clearTimeout(resizeTimeout)
			window.removeEventListener("resize", handleResize)
			clear()
			behavior = undefined
			mapEvents = undefined
			routerRef.current = undefined
			uiRef.current = undefined
			mapRef.current = undefined
			layer = undefined
			platformRef.current = undefined
		}
	}, [])


	//// imposta centro, zoom
	useEffect(() => {
		if (mapRef.current) {
			if (center)	mapRef.current.setCenter(center)
			if (zoom) mapRef.current.setZoom(zoom)
		}
	}, [center, zoom])
	

	//// ridisegna marker e percorso
	useEffect(() => {
        clear()
        addMarkers(markers)
        if (route && markers?.length > 1) {
            drawRoute(markers)
        }
    }, [markers, route, addMarkers, clear, drawRoute])

	//// per marker selezionato forza evento che apre il blob
	useEffect(() => {
		if (selected) {
            markersGroupRef.current.forEach(m => {
                if (m.getGeometry().lat === selected.lat && m.getGeometry().lng === selected.lng) {
                    m.dispatchEvent('pointermove');
                }
            })
        }
	}, [selected])

	// definisce lo stile di default della mappa se non definito className
	if (!className) {
		style = style || { width: '100%', height: '600px', background: 'grey' }
	}

	return (
		<div
			style={style}
			className={className}
			ref={mapDomRef}
		/>
	)
}
